import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { fundraisingService } from '../../services/fundraisingService';

export const useGetLenderApplications = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.fundraising.lender_applications],
    queryFn: () =>
      fundraisingService.lenderApplicationList().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
